import { Box, Divider, InputAdornment, InputLabel, Stack } from "@mui/material";
import React from "react";

import { TextInput } from "components/common/TextInput";
import { CopyButton } from "new-components/buttons/CopyButton";

import { SampleCodeSection } from "./SampleCodeSection";

type TabCodeContentProps = {
  detectorId: string;
};

export function TabCodeContent({ detectorId }: TabCodeContentProps) {
  return (
    <Stack spacing={2} divider={<Divider />} className="pt-2 pb-4 mb-2 border-b-2 border-neutral-400">
      <Box>
        <InputLabel className="uppercase text-sm text-neutral-700 font-bold mb-2">Detector ID:</InputLabel>
        <TextInput
          value={detectorId}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CopyButton valueToCopy={detectorId} />
              </InputAdornment>
            ),
          }}
          disabled
          fullWidth
        />
      </Box>

      <SampleCodeSection detectorId={detectorId} />

      <Box>{/* empty box to add ending divider */}</Box>
    </Stack>
  );
}
